var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 19.5833H19.5833V19.1667V2.83333V2.41667H19.1667H2.83333H2.41667V2.83333V19.1667V19.5833H2.83333H19.1667ZM2.83333 0.916667H19.1667C19.675 0.916667 20.1625 1.1186 20.522 1.47805C20.8814 1.83749 21.0833 2.325 21.0833 2.83333V19.1667C21.0833 20.2199 20.2199 21.0833 19.1667 21.0833H2.83333C2.325 21.0833 1.83749 20.8814 1.47805 20.522C1.1186 20.1625 0.916667 19.675 0.916667 19.1667V2.83333C0.916667 2.325 1.1186 1.83749 1.47805 1.47805C1.83749 1.1186 2.325 0.916667 2.83333 0.916667ZM12.3333 11C12.3333 11.7382 11.7382 12.3333 11 12.3333C10.2618 12.3333 9.66667 11.7382 9.66667 11C9.66667 10.2618 10.2618 9.66667 11 9.66667C11.7382 9.66667 12.3333 10.2618 12.3333 11ZM4.45127 11C5.52452 8.50832 8.04774 6.75 11 6.75C13.9523 6.75 16.4755 8.50833 17.5487 11C16.4755 13.4917 13.9523 15.25 11 15.25C8.04774 15.25 5.52452 13.4917 4.45127 11ZM8.64298 13.357C9.2681 13.9821 10.1159 14.3333 11 14.3333C11.8841 14.3333 12.7319 13.9821 13.357 13.357C13.9821 12.7319 14.3333 11.8841 14.3333 11C14.3333 10.1159 13.9821 9.2681 13.357 8.64298C12.7319 8.01786 11.8841 7.66667 11 7.66667C10.1159 7.66667 9.2681 8.01786 8.64298 8.64298C8.01786 9.2681 7.66667 10.1159 7.66667 11C7.66667 11.8841 8.01786 12.7319 8.64298 13.357Z",
    fill: "#F1F4F9",
    stroke: "#F1F4F9",
    strokeWidth: 0.833333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.8bd2335c4b31d713c57120c83cbbc9e7.svg";
export { ForwardRef as ReactComponent };